import { useLinkStore } from "@/store/link";

import type { ServerLink } from "../serverModel";
import type { BackendReadSession } from "./BackendReadSession";
import { mapLink } from "./mapBackendData";

// links are updated by subscription of link.add / link.remove
// this is not always working (why?), so we explicitly update the links with this function
export async function updateLinks(backendSess: BackendReadSession) {
  type LinkStates = Record<string, "orphan" | "valid" | "existing">;

  const links = await backendSess.getLinks();
  const ids = linkIds(links);
  deleteLinks(ids);
  createLinks(links, ids);

  function linkIds(ls: ServerLink[]) {
    const ids: LinkStates = {};
    ls.forEach((l) => {
      ids[l.id] =
        useLinkStore().cardsByLink(l.from_sticky_id).length > 0 &&
        useLinkStore().cardsByLink(l.to_sticky_id).length > 0
          ? "valid"
          : "orphan";
    });
    return ids;
  }

  function deleteLinks(ids: LinkStates) {
    for (const link of useLinkStore().links) {
      if (!ids[link.id]) {
        // useLinkStore().remove(link.id);
      } else if (ids[link.id] === "valid") {
        ids[link.id] = "existing";
      }
    }
  }

  function createLinks(ls: ServerLink[], ids: LinkStates) {
    ls.forEach((l) => {
      if (ids[l.id] === "valid") {
        useLinkStore().add(mapLink(l));
      }
    });
  }
}
